<div class="container">
  <div class="container__header">
    <h6>Permission Groups</h6>
  </div>
  <div class="container__items">
    <div
      class="container__items__item"
      *ngFor="let role of roles"
      (click)="onRoleSelected(role)"
      [class.selected]="selectedRole?.id === role.id"
    >
      <mat-icon>{{ role.account_id ? 'lock_open' : 'lock' }}</mat-icon
      >{{ role.label }}
    </div>
  </div>
</div>
